import { useSyncExternalStore } from 'react';

const emptySubscribe = () => () => {};

export const useIsSSR = (): boolean => {
  const isSSR = useSyncExternalStore(
    emptySubscribe,
    () => false,
    () => true,
  );

  return isSSR;
};
